<template>
  <MyModal
    title="发电量计算"
    :height="isShowDetail ? '590px' : 'auto'"
    width="454px"
    :style="{ top: '95px', left: '425px' }"
    v-if="isShow"
    @closeClick="handleCloseModalClick"
  >
    <div class="power-content">
      <template>
        <div class="deploy-content">
          <div class="row">
            <div
              :class="[
                'row-item',
                {
                  place: item.place == 1,
                },
              ]"
              v-for="(item, index) in seniorItemList"
              :key="index"
            >
              <div class="row-item-core">
                <div class="key" :title="item.label">{{ item.label }}</div>
                <div class="value">
                  <StandInput
                    v-model="item.value"
                    :myType="item.type"
                    :onlyNumber="item.onlyNumber"
                    :unit="item.unit"
                    :interger="item.interger"
                    :selectOptions="item.selectOptions"
                    :multiple="item.multiple"
                    :readonly="item.readonly"
                    @change="(val) => changeCap(val, item)"
                  ></StandInput>
                </div>
              </div>
            </div>
            <!-- <div class="row-item">
            <div class="row-item-core">
              <div class="key">高级设置</div>
              <div class="value">
                <div class="stand-switch-core">
                  <el-switch v-model="advanced" active-color="#6290F7">
                  </el-switch>
                </div>
              </div>
            </div>
          </div> -->
            <div v-if="advanced">
              <div
                :class="[
                  'row-item',
                  {
                    place: item.place == 1,
                  },
                ]"
                v-for="(item, index) in seniorItemList"
                :key="index"
              >
                <div class="row-item-core">
                  <div class="key">{{ item.label }}</div>
                  <div class="value">
                    <StandInput
                      v-model="item.value"
                      :myType="item.type"
                      :onlyNumber="item.onlyNumber"
                      :unit="item.unit"
                      :interger="item.interger"
                      :selectOptions="item.selectOptions"
                      :multiple="item.multiple"
                      :readonly="item.readonly"
                      @change="(val) => changeCap(val, item)"
                    ></StandInput>
                  </div>
                  <!-- <el-tooltip
                    effect="light"
                    placement="right"
                    class="shear-tooltip"
                    popper-class="my-tooltip-right"
                    v-if="item.key === 'shear'"
                  >
                    <div slot="content" class="shear-tooltip-con">
                      <span>说明: 切变值大于此值时，系统将自动推荐高塔筒</span>
                    </div>
                    <i class="el-icon-question"> </i>
                  </el-tooltip> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="calc-area">
          <ct-button size="small" type="primary" :btnClick="handleCalc">
            开始计算
          </ct-button>
          <!-- <el-tooltip
            effect="light"
            placement="top-start"
            class="ra-tooltip"
            popper-class="my-tooltip"
          >
            <div slot="content" class="ra-tooltip-con">
              <span
                >说明：基于机位排布方案，给出考虑尾流及折减系数后的上网电量及其它相关参数</span
              >
            </div>
            <i class="el-icon-question"> </i>
          </el-tooltip> -->
        </div>
      </template>
      <div v-if="isShowDetail">
        <div style="height:240px;overflow-y:auto;background:rgba(255,255,255,.4)">
          <template v-if="isCalcDataShow">
            <div v-if="isCalcDataShow" class="deploy-container">
              <div class="deploy-content line" style="white-space:nowrap;">
                <div
                    class="params-item"
                    v-for="(item, index) in eneryParamsList"
                    :key="index"
                >
                  <div class="key">{{ item.name }}{{ item.unit }}</div>
                  <div class="value" v-for="it in item.value">
                    <el-tag>{{ it }}</el-tag>
                  </div>
                  <!--              <div class="unit">{{ item.unit }}</div>-->
                </div>
              </div>
            </div>

            <div v-if="!!chartOption" class="chart-content">
              <Chart :option="chartOption"></Chart>
            </div>
          </template>
          <template v-else>
          <div v-if="!noData" class="deploy-container">
            <div class="deploy-content" style="white-space:nowrap;" >
              <div
                  class="params-item"
                  v-for="(item, index) in singleEneryParamsList"
                  :key="index"
              >
                <div class="key">{{ item.name }}</div>
                <div class="value">
                  <el-tag>{{ item.value }}</el-tag>
                </div>
                <div v-if="!!item.unit" class="unit">{{ item.unit }}</div>
              </div>
            </div>
          </div>
          <!--        <div class="deploy-content" v-else>-->
          <!--          点击地图上的风机查看详情-->
          <!--        </div>-->

          <div v-if="!!singleChartOption" class="chart-content">
            <Chart :option="singleChartOption"></Chart>
          </div>
        </template>
        </div>
        <div style="text-align:right;padding-top:15px;">
          <ct-button size="small" type="primary" :btnClick="handleExportPower">导出电量</ct-button>
        </div>
      </div>
    </div>
  </MyModal>
</template>

<script>
import MyModal from './modal';
import StandInput from './stand-input';
import { mapGetters } from 'vuex';
import Chart from './chart';
import { filterPowerCurveData } from '../utils';
import { hasPermission } from '@/permission/index';
import { getTurbineTypeList } from '../service';
import { getToken } from '@/utils';
export default {
  components: {
    MyModal,
    StandInput,
    Chart,
  },
  computed: {
    ...mapGetters('WindFarm', ['projectList', 'powerTurbineList']),
    activeName() {
      return this.tabList.find(i => i.active).name;
    },
    noData() {
      return this.singleEneryParamsList.every(i => !i.value);
    },
    noCalcData() {
      return this.eneryParamsList.every(i => !i.value);
    },
    synthesizeLoss() {
      var item = this.seniorItemList.find(object => object.key === 'synthesizeLoss')
      return item.value;
    },
  },
  data() {
    return {
      isExportPower: false,
      isCalcDataShow: true,
      advanced: false,
      powerCurvedata: [],
      isShow: true,
      chartOption: null,
      singleChartOption: null,
      isShowDetail: false,
      tableData: [
        {
          index: 1,
          type: '控制和湍流折减',
          rangeValue: '5%左右',
        },
        {
          index: 2,
          type: '叶片污染折减',
          rangeValue: '6%以内',
        },
        {
          index: 3,
          type: '风电机组可利用率折减',
          rangeValue: '5%~10%',
        },
        {
          index: 4,
          type: '风电机组功率曲线保证率折减',
          rangeValue: '5%',
        },
        {
          index: 5,
          type: '场用电、线损等折减',
          rangeValue: '3％-10％',
        },
        {
          index: 6,
          type: '气候影响折减',
          rangeValue: '3％-7％',
        },
        {
          index: 7,
          type: '软件计算误差折减',
          rangeValue: '5％-10％',
        },
        {
          index: 8,
          type: '电网频率波动与限电等折减',
          rangeValue: '3％-5％',
        },
      ],
      tabList: [
        {
          name: '全场',
          active: true,
        },
        {
          name: '单风机',
          active: false,
        },
      ],
      eneryParamsList: [
        {
          name: '轮毂高度',
          key: 'hubHeight',
          unit: '',
          value: [],
        },
        {
          name: '上网电量',
          key: 'annualEnergy',
          unit: 'MWh',
          value: '-',
        },
        {
          name: '满发小时数',
          key: 'fullLoadHour',
          unit: 'h',
          value: '-',
        },
        {
          name: '平均尾流值',
          key: 'flowLoss',
          unit: '%',
          value: 0,
        },
        {
          name: '折减系数(除尾流)',
          key: 'ratio',
          unit: '%',
          value: '-',
        },
        {
          name: '平均风速',
          key: 'wspd',
          unit: 'm/s',
          value: '-',
        },
        {
          name: '最大风速',
          key: 'wspdMax',
          unit: 'm/s',
          value: '-',
        },
        {
          name: '最小风速',
          key: 'wspdMin',
          unit: 'm/s',
          value: '-',
        },
        {
          name: '平均风功率密度',
          key: 'wpd',
          unit: 'W/㎡',
          value: '-',
        },
        {
          name: '最大风功率密度',
          key: 'wpdMax',
          unit: 'W/㎡',
          value: '-',
        },
        {
          name: '最小风功率密度',
          key: 'wpdMin',
          unit: 'W/㎡',
          value: '-',
        },
      ],
      singleEneryParamsList: [
        {
          name: '经度',
          key: 'lon',
          unit: '',
          value: '',
        },
        {
          name: '纬度',
          key: 'lat',
          unit: '',
          value: '',
        },
        {
          name: '高程',
          key: 'altitude',
          unit: 'm',
          value: '',
        },
        {
          name: '尾流损失',
          key: 'flowLoss',
          unit: '%',
          value: '',
        },
        {
          name: '综合折减',
          key: 'synthesizeLoss',
          unit: '%',
          value: '',
        },
        {
          name: '理论发电量',
          key: 'annualEnergy',
          unit: 'MWh',
          value: '',
        },
        {
          name: '满发小时数',
          key: 'fullLoadHour',
          unit: 'h',
          value: '',
        },
        {
          name: '平均风速',
          key: 'wspd',
          unit: 'm/s',
          value: '',
        },
        {
          name: 'A',
          key: 'weibullA',
          unit: '',
          value: '',
        },
        {
          name: 'K',
          key: 'weibullK',
          unit: '',
          value: '',
        },
      ],
      // flowLoss: '',
      turbineTypeList: [],
      turbineInfo: [],
      windfarmEnergyInfo: '',
      turbineId: '',
      height: [],
      seniorItemList: [
        {
          label: '机组型号',
          key: 'typeName',
          value: null,
          // interger: true,
          type: 'text',
          readonly: true,
        },
        {
          label: '轮毂高度',
          key: 'hubHeight',
          value: null,
          type: 'text',
          readonly: true,
        },
        {
          label: '综合折减',
          key: 'synthesizeLoss',
          value: null,
          onlyNumber: true,
          // interger: true,
          type: 'input',
        },
        {
          label: '尾流影响折减',
          key: 'flowLoss',
          value: null,
          onlyNumber: true,
          // interger: true,
          readonly: false, //可研不能修改尾流
          type: 'input',
        },
        {
          label: '控制与湍流影响折减',
          key: 'controlTurbulenceLoss',
          value: null,
          onlyNumber: true,
          // interger: true,
          type: 'input',
        },
        {
          label: '叶片污染折减',
          key: 'bladeLoss',
          value: null,
          onlyNumber: true,
          // interger: true,
          type: 'input',
        },
        {
          label: '风电机组利用率',
          key: 'turbineLoss',
          value: null,
          onlyNumber: true,
          // interger: true,
          type: 'input',
        },
        {
          label: '功率曲线折减',
          key: 'powerCurveLoss',
          value: null,
          onlyNumber: true,
          // interger: true,
          type: 'input',
        },
        {
          label: '厂用电、线损等能量损耗',
          key: 'useLineLoss',
          value: null,
          onlyNumber: true,
          // interger: true,
          type: 'input',
        },
        {
          label: '气候影响停机',
          key: 'whetherLoss',
          value: null,
          onlyNumber: true,
          // interger: true,
          type: 'input',
        },
        {
          label: '风资源不确定性及软件计算误差折减',
          key: 'softLoss',
          value: null,
          onlyNumber: true,
          // interger: true,
          type: 'input',
        },
        {
          label: '基础平台平整折减',
          key: 'baseLoss',
          value: null,
          onlyNumber: true,
          // interger: true,
          type: 'input',
        },
        {
          label: '电网限电',
          key: 'gridlimitLoss',
          value: null,
          onlyNumber: true,
          // interger: true,
          type: 'input',
        },
        {
          label: '其他因素影响',
          key: 'otherLoss',
          value: null,
          onlyNumber: true,
          // interger: true,
          type: 'input',
        },
      ],
      EnergyTurbine: null
    };
  },
  created() {
    this.queryAllPower();
    this.$bus.$on('checkPowerInPower', this.checkSingleTurPower);
    this.$store.commit('WindFarm/SET_FENGJIBIANHAOFLAG', true);

    setTimeout(() => {
      if (this.hasPerms('layer-landWspd')) {
        this.$bus.$emit('checkLayer', ['fengziyuan']);
      }
      this.$bus.$emit('checkLayer', 'tiandi');
      this.$bus.$emit('getCluster', false);
    });
  },
  beforeDestroy() {
    this.$bus.$off('checkPowerInPower', this.checkSingleTurPower);
    this.$store.commit('WindFarm/SET_FENGJIBIANHAOFLAG', true);
    // this.$store.commit('WindFarm/UPDATE_TUILIST', {
    //   activeId: -1
    // });
  },
  methods: {
    changeCap(val, item) {
      item.value = val;
      if (item.key === 'synthesizeLoss') return;

      const currentFormData = this.seniorItemList.reduce((acc, cur) => {
        acc[cur.key] = cur.value;

        return acc;
      }, {});

      this.$postForm('/windfarm/station/calculateSynthesizeLoss', {
        data: {
          // flowLoss: this.flowLoss,
          ...currentFormData,
          synthesizeLoss: this.synthesizeLoss,
          planId: this.$route.query.planId,
        },
        showError: true,
      }).then((res) => {
        const { data = {} } = res;
        const { synthesizeLoss } = data;
        this.seniorItemList[2].value = synthesizeLoss;
      });
    },
    hasPerms(perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms);
    },
    changeTurbine(value) {
      this.$bus.$emit('getCluster', false);
      if (value !== '') {
        this.checkSingleTurPower({ turbineId: value });
      } else {
        this.turbineInfo.forEach((item) => {
          this.$store.commit('WindFarm/UPDATE_POWERLIST', {
            activeId: item.turbineId,
            force: false,
          });
        });
        this.isCalcDataShow = true;
      }
    },
    // queryAutoParams() {
    //   console.log(this.powerTurbineList);
    //   this.turbineInfo = this.powerTurbineList?.map?.((item, index) => {
    //     return {
    //       turbineInfo: { ...item },
    //       label: '#' + (index + 1),
    //       value: item.turbineId,
    //       isShow: true
    //     };
    //   });
    //   this.turbineInfo?.unshift?.({ label: '全场(默认)', value: '' });
    // },
    handleCloseModalClick() {
      this.turbineInfo.forEach((item) => {
        this.$store.commit('WindFarm/UPDATE_POWERLIST', {
          activeId: item.turbineId,
          force: false,
        });
      });
      // this.isShow=false;
      this.$bus.$emit(
        'farmClick',
        2
      );
      // this.$bus.$emit('farmClick', 1);
    },
    handleCalc() {
      // this.$postForm('/windfarm/windfarm/computeStationEnergy', {

      const currentFormData = this.seniorItemList.reduce((acc, cur) => {
        acc[cur.key] = cur.value;

        return acc;
      }, {});

      this.$postForm('/windfarm/station/saveOverallCoefficient', {
        data: {
          // flowLoss: this.flowLoss,
          ...currentFormData,
          synthesizeLoss: this.synthesizeLoss,
          planId: this.$route.query.planId,
          planIds: this.EnergyTurbine.planIds,
        },
        showError: true,
        showLoading: {
          mask: true,
          loadingContent:
            '基于机位排布方案，给出考虑尾流及折减系数后的上网电量及其它相关参数',
        },
        showSuccess: true,
      }).then(() => {
        // this.$store.dispatch('WindFarm/getPowerTurbineList', {
        //   params: {
        //     planId: this.$route.query.planId
        //   }
        // });
        this.$bus.$emit('getCluster', false);
        this.turbineId = '';
        this.handleListPower();
        this.changeTurbine(this.turbineId);
        this.queryAllPower();
        this.$bus.$emit('updatePlanToolIconStatus');
        // setTimeout(() => {
        //   this.queryAutoParams();
        // });
      });
    },
    handleListPower() {
      this.$fetch('/windfarm/station/getEnergyTurbineList', {
        showError: true,
        params: {
          planId: this.$route.query.planId,
        },
      }).then((res) => {
        const { data = {} } = res || {};
        const { energyParam, turbineList } = data;
        const { synthesizeLoss } = energyParam;

        var list = turbineList.map(i => ({
          ...i,
          synthesizeLoss: synthesizeLoss,
          isShow: true,
        }));
        this.turbineInfo = list.map((item, index) => {
          return {
            turbineInfo: { ...item },
            label: '#' + (index + 1),
            value: item.turbineId,
            isShow: true,
          };
        });
        this.turbineInfo.unshift({ label: '全场(默认)', value: '' });
        this.$store.commit('WindFarm/SET_POWERTURLIST', list);
        this.$store.commit('WindFarm/UPDATE_POWERLIST');
      });
    },
    checkSingleTurPower(data) {
      this.turbineId = data.turbineId;
      this.isCalcDataShow = false;
      // if (this.activeName === '单风机') {

      const turInfo = this.turbineInfo.find(
        (i) => i.value === data.turbineId
      )?.turbineInfo;
      this.singleEneryParamsList.forEach((item) => {
        item.value = turInfo[item.key];
      });
      this.$store.commit('WindFarm/UPDATE_POWERLIST', {
        activeId: data.turbineId,
        force: true,
      });
      // this.$fetch('/windfarm/windfarm/getTurbineEnergy', {
      //   params: {
      //     turbineId: data.turbineId,
      //     planId: this.$route.query.planId
      //   },
      //   showError: true
      // }).then(res => {
      //   const { data } = res;
      //   const { turbineEnergyInfo = [], turbinePowercurve = [] } = data;
      //
      //   const itemInfo = turbineEnergyInfo[0];
      //
      //   this.singleEneryParamsList.forEach(item => {
      //     item.value = itemInfo[item.key];
      //   });
      //
      //   this.singleChartOption = this.getSingleChartOption(
      //     turbinePowercurve,
      //     itemInfo.turbineType
      //   );
      // });
      // }
    },

    getSingleChartOption(turbinePowercurve, turbineType) {
      const data = turbinePowercurve.map(i => [i.wspd, i.power]);

      return {
        legend: {
          show: true,
          data: [turbineType],
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          show: true,
          formatter: (params) => {
            const { data = [] } = params;
            return `风速：${data[0]}m/s </br> 风功率：${data[1]}W/㎡ `;
          },
        },
        grid: {
          right: '80',
          left: '50',
        },
        textStyle: {
          color: '#fff',
        },
        xAxis: {
          nameLocation: 'end',
          scale: true,
          boundaryGap: false,
          type: 'category',
          // max: 12,
          name: '风速(m/s)',
          axisTick: {
            show: true,
          },
          axisLine: {
            lineStyle: {
              color: '#fff',
            },
          },
        },
        yAxis: {
          splitNumber: 5,
          axisLine: {
            lineStyle: {
              color: '#fff',
            },
          },
          name: '风功率(W/㎡)',
          type: 'value',
        },
        series: [
          {
            name: turbineType,
            data: data,
            type: 'line',
          },
        ],
      };
    },

    getChartOption(curveList = {}) {
      const colors = [
        '#F44336',
        '#409eff',
        '#3F51B5',
        '#00BCD4',
        '#009688',
        '#8BC34A',
        '#FF9800',
        '#607D8B',
        '#9E9E9E',
        '#795548',
        '#673AB7',
        '#03A9F4',
      ];
      return {
        color: colors,
        grid: {
          left: '5%',
          right: '5%',
          bottom: '8%',
          top: '15%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['功率', '推力系数'],
          icon: "rect",
          itemHeight: 2,
          top: 10
        },
        xAxis: {
          name: '风速（m/s）',
          type: 'value',
          splitNumber: 5,
          min: 0,
          max: 25,
          nameGap: 25,
          nameLocation: 'center',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
            },
          },
          axisLine: {
            lineStyle: {
              type: 'solid',
              //color: '#fff', //左边线的颜色
            },
          },
          axisLabel: {
            textStyle: {
              color: '#222233', //坐标值得具体的颜色
            },
          },

          onZero: false,
        },
        yAxis: [
          {
            position: 'left',
            type: 'value',
            name: '功率（kW）',
            min: 0,
            max: (value) => {
              if (value.max <= 10) {
                return 12;
              }

              let max = value.max * 1.2;
              let val = max / 5;
              const round = true;
              const exponent = Math.floor(Math.log(val) / Math.LN10);
              const exp10 = Math.pow(10, exponent);
              const f = val / exp10; // 1 <= f < 10
              let nf;
              if (round) {
                if (f < 1.5) {
                  nf = 1;
                } else if (f < 2.5) {
                  nf = 2;
                } else if (f < 4) {
                  nf = 3;
                } else if (f < 7) {
                  nf = 5;
                } else {
                  nf = 10;
                }
              } else {
                if (f < 1) {
                  nf = 1;
                } else if (f < 2) {
                  nf = 2;
                } else if (f < 3) {
                  nf = 3;
                } else if (f < 5) {
                  nf = 5;
                } else {
                  nf = 10;
                }
              }
              val = nf * exp10;
              return val * 5 <= value.max ? val * 6 : val * 5;
            },
            axisLine: {
              lineStyle: {
                type: 'solid',
              },
            },
            axisLabel: {
              show: true,
            },
            // axisTick: {
            //   lineStyle: {
            //     color: '#222233'
            //   } //y轴坐标刻度颜色
            // },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
              },
            },
          },
          {
            position: 'right',
            type: 'value',
            name: '推力系数',
            axisLabel: {
              show: true,
            },
            // axisTick: {
            //   lineStyle: {
            //     color: '#222233'
            //   } //y轴坐标刻度颜色
            // },
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dashed',
              },
            },
          },
        ],
        series: [
          {
            name: '功率',
            type: 'line',
            smooth: true,
            data: curveList.power,
            showSymbol: false,
            yAxisIndex: '0',
          },
          {
            name: '推力系数',
            type: 'line',
            smooth: true,
            data: curveList.thrust,
            showSymbol: false,
            yAxisIndex: '1',
          },
        ],
      };
    },

    queryAllPower() {
      // this.$fetch('/windfarm/windfarm/getWindfarmEnergy', {
      this.$fetch('/windfarm/station/getEnergyList', {
        params: {
          planId: this.$route.query.planId,
        },
        showError: true,
      }).then((res) => {
        const { data } = res;
        const { energyParam, energyList = [] } = data;
        // this.flowLoss = energyParam.flowLoss;
        // this.synthesizeLoss = energyParam.synthesizeLoss;
        let eneryInfo = energyList[0];
        if (eneryInfo.flowLoss != null) {
          this.isShowDetail = true;
        } else {
          this.isShowDetail = false;
        }
        const { curveList = [] } = energyList[0] || [];
        this.seniorItemList.forEach(i => {
          i.value = energyParam[i.key];
        });

            this.$fetch('/windfarm/station/getEnergyTurbineList', {
              showError: true,
              params: {
                planId: this.$route.query.planId,
              },
            }).then((res) => {
              const { data = {} } = res || {};
              const { energyParam, turbineList } = data;
              const { hubHeights } = energyParam;
              this.seniorItemList[1].value = hubHeights;
              this.seniorItemList[0].value = turbineList[0].typeName;
              this.EnergyTurbine = energyParam;
            })
        // 去除相同风速的同样的数据
        let obj = {};
        let curveData = curveList.reduce(function (prevArr, currentItem) {
          obj[currentItem.wspd]
            ? ''
            : (obj[currentItem.wspd] = true && prevArr.push(currentItem));
          return prevArr;
        }, []);
        this.powerCurvedata = filterPowerCurveData(curveData);
        if (energyList.length != 0) {
          this.eneryParamsList.forEach((item) => {
            // item.value = eneryInfo[item.key];
            item.value = [];
            for(let i=0;i<energyList.length;i++){
              let obj = energyList[i];
              item.value.push(obj[item.key]);
            }
          });
        }
        getTurbineTypeList({ projectId: this.$route.query.projectId }).then(
          (res) => {
            this.turbineList = res?.data?.turbineTypeList || [];
            // this.formData.turbineTypeId = this.turbineList[0].turbineTypeId;
            let item = this.seniorItemList.find(object => object.key === 'typeName');
            const turbine = this.turbineList?.find(
              (v) => v.turbineType === item.value
            );
            this.seniorItemList[1].selectOptions = turbine?.hubHeightList?.map(
              (v) => {
                return {
                  label: v.hubHeight,
                  value: Number(v.hubHeight),
                };
              }
            );
          }
        );
        this.chartOption = this.getChartOption(this.powerCurvedata);
      });
    },
    handleTabClick(item) {
      this.tabList.forEach(i => {
        if (i !== item) {
          i.active = false;
        } else {
          i.active = true;
        }
      });

      this.singleChartOption = null;
    },
    handleExportPower(){
      if(this.isExportPower){
        return false;
      }
      this.isExportPower = true;
      const apiKey = getToken();
      // const loading = this.$loading({
      //   text: '正在导出风机，请稍后...',
      //   spinner: 'el-icon-loading',
      // });

      this.$fetch(`/windfarm/station/exportPowerList?apiKey=${apiKey}&planId=${this.$route.query.planId}`, {
        method: 'post',
        showError: true,
        // showLoading: {
        //   mask: true,
        //   loadingContent: '正在下载请稍后'
        // },
        noJudge: true,
        responseType: 'blob',
      })
          .then(res => {
            if(res.status == 401){
              this.errorMessage(res.data);
              return;
            }
            if(res.status == 402){
              this.$message.error("数据正在准备中，请稍后再试");
              return;
            }
            const blob = new Blob([res.data]);

            var link = document.createElement('a');
            var fileURL = URL.createObjectURL(blob);
            link.target = '_blank';
            link.href = fileURL;
            link.download = '电量.csv'; //文件名称
            link.click();
            // loading.close();
            this.isExportPower = false;
          })
          .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
  ::v-deep.wind-farm-modal-wrapper .content{
    overflow-y: auto;
  }
.desc-tooltip {
  margin-left: 10px;
  &::before {
    content: url('../images/tootip-desc.png');
  }
}
.desc-tooltip-con {
  width: 210px;
}
.adjust-desc-click {
  width: 320px;
  margin-top: 8px;
  font-weight: 800;
  color: #ff8b24;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.power-content {
  /*padding: 5px 10px 20px 10px;*/
  font-size: 12px;
  .adjust-desc-new {
    display: contents;
    margin-top: 10px;
    font-weight: 800;
    color: #ff8b24;
    line-height: 20px;
  }
  .core {
    // background-color: #fff;
    border-radius: 7px;
    // padding: 10px;
    .tab {
      //user-select: none;
      display: flex;
      align-items: center;
      .tab-item {
        height: 28px;
        width: 85px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        border: 2px solid #0877be;
        cursor: pointer;
        &:first-child {
          border-radius: 5px 0px 0px 5px;
        }
        &:last-child {
          border-radius: 0px 5px 5px 0px;
        }
        &.is-active {
          background-color: #0877be;
          color: #fff;
        }
      }
    }
  }

  .calc-area {
    /*display: flex;*/
    text-align: center;
    margin-bottom: 10px;
  }
  .deploy-container{
    width: 100%;
    overflow-x: auto;
  }
  .deploy-content {
    padding: 10px;
    color: @black-color;
    .el-tag {
      color:@black-color;
    }
    .params-item {
      display: flex;
      align-items: center;
      & > div {
        margin-right: 5px;
      }
      .key {
        width: 140px;
        font-weight: bold;
      }
      .value {
        width: 70px;
        color: @black-color;
        .el-tag {
          border: none;
          background: none;
        }
      }
      .unit {
        font-size: 12px;
        color: #fff;
      }
    }
  }

  .line {
    border-top: 1px solid rgb(220, 223, 230);
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    .row-item {
      display: flex;
      align-items: center;
      width: 185px;
      margin-left: 0px;
      align-items: center;
      margin-bottom: 5px;
      justify-content: space-around;
      &.place {
        width: 100%;
        &:nth-child(2n) {
          margin-left: 0px;
        }
        &:nth-child(2n + 1) {
          margin-left: 0px;
        }
        .row-item-core {
          display: flex;
          align-items: center;
          .key {
            margin-right: 5px;
            width: 84px;
            font-weight: 400;
            font-size: 12px;
          }
          .value {
            width: 280px;
            font-size: 12px;
          }
        }
      }
      &:nth-child(2n + 1) {
        margin-left: 0px;
      }
      &:nth-child(2n) {
        margin-left: 20px;
      }
      .row-item-core {
        display: flex;
        align-items: center;
        .key {
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          /* 设置行数 */
          -webkit-line-clamp: 2;
          /* 设置超出的部分如何显示 */
          text-overflow: ellipsis;
          margin-right: 5px;
          min-width: 98px;
          padding-left: 5px;
          font-weight: 400;
          font-size: 12px;
        }
        .value {
          min-width: 95px;
          font-size: 12px;
        }
      }
    }
  }

  .chart-content {
    border-radius: 7px;
    padding: 5px;
    height: 300px;
    width: 100%;
  }
}
</style>
